import React from 'react';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Home from './Pages/Home';
import Booking from './Pages/Booking';
import Exhibitors from './Pages/Exhibitors';
import Contact from './Pages/Contact'
import Error404 from './Pages/Error';        


const Routess = () => {
    return ( 
    
    <BrowserRouter>
    <Routes>
    <Route path='/' element={<Home />}/>
    <Route path='/Booking' element={<Booking />}/>
    <Route path='/Exhibitors' element={<Exhibitors />}/>
    <Route path='/Contact'  element={<Contact/>} />
    <Route path='*' element={<Error404 />}/> 
    </Routes>
    </BrowserRouter>
        
     );
}
 
export default Routess;